const turnosRecepcionadosInitialState = {
    turnosRecepcionados : {
        data: [], 
        loading: false, 
        error: false 
    }
}

export default turnosRecepcionadosInitialState; 